import { AxiosError, AxiosRequestConfig, AxiosResponse, RawAxiosRequestHeaders } from 'axios';
import { goBackendApiValidator, phpBackendApiValidator } from 'utils/response-validators';
import { getShopifySessionToken } from 'utils/shopifySessionToken';
import { Response } from '../../models/Response';
import { api } from '../../utils/axios';

const handleError = (error: object) => {
    // if (error.response.data.type) {
    //     ToastUtils.error('Error occured!');
    // } else {
    //     ToastUtils.error('Error occured!');
    // }
};

const getRequestHeaders = (token: string, config?: AxiosRequestConfig<object>): RawAxiosRequestHeaders => {
    return {
        ...config?.headers,
        Authorization: `Bearer ${token}`,
    } satisfies RawAxiosRequestHeaders;
};

export const apiFactory = (baseUrl: string, validator: (status: number) => boolean) => {
    const get = <Type>(path: string, params?: object, config?: AxiosRequestConfig<object>): Promise<Response<Type>> => {
        return getShopifySessionToken({ method: 'GET', path }).then((token) => {
            return api
                .get(baseUrl + path, {
                    ...config,
                    params,
                    validateStatus: validator,
                    headers: getRequestHeaders(token, config),
                })
                .then((resp: AxiosResponse) => {
                    return Response.createSuccessful<Type>(resp.data, resp.status);
                })
                .catch((error: AxiosError) => {
                    // handleError(error);
                    throw error;
                });
        });
    };

    const post = <Type>(path: string, params?: object, config?: AxiosRequestConfig): Promise<Response<Type>> => {
        return getShopifySessionToken({ method: 'POST', path }).then((token) => {
            return api
                .post(baseUrl + path, params, { ...config, headers: getRequestHeaders(token, config) })
                .then((resp: AxiosResponse) => {
                    return Response.createSuccessful<Type>(resp.data, resp.status);
                })
                .catch((error: AxiosError) => {
                    // handleError(error);
                    throw error;
                });
        });
    };
    const patch = <Type>(
        path: string,
        params?: object | number,
        config?: AxiosRequestConfig
    ): Promise<Response<Type>> => {
        return getShopifySessionToken({ method: 'PATCH', path }).then((token) => {
            return api
                .patch(baseUrl + path, params, { ...config, headers: getRequestHeaders(token, config) })
                .then((resp: AxiosResponse) => {
                    return Response.createSuccessful<Type>(resp.data, resp.status);
                })
                .catch((error: AxiosError) => {
                    // handleError(error);
                    throw error;
                });
        });
    };

    const put = <Type>(path: string, params?: object, config?: AxiosRequestConfig): Promise<Response<Type>> => {
        return getShopifySessionToken({ method: 'PUT', path }).then((token) => {
            return api
                .put(baseUrl + path, params, { ...config, headers: getRequestHeaders(token, config) })
                .then((resp: AxiosResponse) => {
                    return Response.createSuccessful<Type>(resp.data, resp.status);
                })
                .catch((error: AxiosError) => {
                    // handleError(error);
                    throw error;
                });
        });
    };

    const deleteMethod = <Type>(path: string, config?: AxiosRequestConfig): Promise<Response<Type>> => {
        return getShopifySessionToken({ method: 'DELETE', path }).then((token) => {
            return api
                .delete(baseUrl + path, { ...config, headers: getRequestHeaders(token, config) })
                .then((resp: AxiosResponse) => {
                    return Response.createSuccessful<Type>(resp.data, resp.status);
                })
                .catch((error: AxiosError) => {
                    // handleError(error);
                    throw error;
                });
        });
    };

    return { get, post, put, patch, deleteMethod };
};

export const phpBackendApi = () => {
    return apiFactory(`${import.meta.env.VITE_APP_BACKEND_URL}`, phpBackendApiValidator);
};

export const goBackendApi = () => {
    return apiFactory(`${import.meta.env.VITE_APP_GO_BACKEND_URL}`, goBackendApiValidator);
};

/**
 * @deprecated Use apiFactory instead
 */
const deleteMethod = <Type>(path: string): Promise<Response<Type>> => {
    return phpBackendApi().deleteMethod<Type>(path);
};

/**
 * @deprecated Use apiFactory instead
 */
const post = <Type>(path: string, params?: object, config?: AxiosRequestConfig<object>): Promise<Response<Type>> => {
    return phpBackendApi().post<Type>(path, params, config);
};

/**
 * @deprecated Use apiFactory instead
 */
const get = <Type>(path: string, params?: object): Promise<Response<Type>> => {
    return phpBackendApi().get<Type>(path, params);
};

/**
 * @deprecated Use apiFactory instead
 */
const patch = <Type>(path: string, params?: object): Promise<Response<Type>> => {
    return phpBackendApi().patch<Type>(path, params);
};

/**
 * @deprecated Use apiFactory instead
 */
const httpApi = { post, get, patch, delete: deleteMethod };

export default httpApi;
